export default "__VITE_ASSET__BWb7Sq4X__"